<template>
    <div class="o-slider">
        <template v-if="$slots.default">
            <tiny-slider
                ref="slider"
                v-bind="options"
                @transitionStart="onTransitionStart"
                @indexChanged="onIndexChange"
                @transitionEnd="onTransitionEnd"
            >
                <slot />
            </tiny-slider>
        </template>
        <tiny-slider
            v-else-if="slidesHtml"
            ref="slider"
            v-bind="options"
            v-html="slidesHtml"
            @transitionStart="onTransitionStart"
            @indexChanged="onIndexChange"
            @transitionEnd="onTransitionEnd"
        ></tiny-slider>
    </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider'

const TinySlider = {
    extends: VueTinySlider,
    inheritAttrs: false
}

export default {
    components: {
        TinySlider
    },
    props: {
        content: {
            type: String,
            required: false,
            default: undefined
        },
        options: {
            type: Object,
            default: () => {
                return {
                    mouseDrag: true,
                    items: 1,
                    swipeAngle: 45,
                    nav: true,
                    autoplay: true,
                    loop: true,
                    'autoplay-timeout': 5000,
                    'autoplay-button': false,
                    'autoplay-button-output': false,
                    preventScrollOnTouch: 'auto'
                }
            }
        }
    },
    computed: {
        slidesHtml() {
            const slider = document.createElement('div')

            slider.innerHTML = this.content?.trim()
            const autoplayTimeOutEl = slider.querySelector('[autoplay-timeout]')
            const autoplayTimeOut = autoplayTimeOutEl?.getAttribute(
                'autoplay-timeout'
            )
            if (autoplayTimeOut) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.options['autoplay-timeout'] = +autoplayTimeOut
            }

            return slider?.innerHTML
        }
    },
    methods: {
        fixSliderHeight(slider) {
            const index = slider.displayIndex
            const slide = slider.slideItems[index]
            const slideHeight = slide.offsetHeight

            const tnsOvh = this.$el.querySelector('.tns-ovh')
            tnsOvh.style.height = `${slideHeight}px`
        },
        onTransitionStart(slider) {
            this.fixSliderHeight(slider)
            this.$nextTick(() => {
                this.$emit('transitionStart', slider)
            })
        },
        onTransitionEnd(slider) {
            this.$emit('transitionEnd')
        },
        onIndexChange(slider) {
            this.$emit('indexChanged')
        }
    }
}
</script>

<style lang="scss">
@import 'tiny-slider/src/tiny-slider';
</style>
